import type { FC } from "react";

import { TiersBenefits as UITiersBenefits } from "@jti/loyalty/components/TiersBenefits";

import type { tiersBenefitsInputs } from "./TiersBenefits.builder";

type TiersBenefitsBuilderProps = BuilderComponentProps<typeof tiersBenefitsInputs>;

export const TiersBenefits: FC<TiersBenefitsBuilderProps> = ({
  general,
  tier1,
  tier2,
  tier3,
  benefitsSections = [],
  componentId,
}) => {
  return (
    <UITiersBenefits
      general={general}
      tier1={{ ...tier1, altText: tier1.altText ?? "" }}
      tier2={{ ...tier2, altText: tier2.altText ?? "" }}
      tier3={{ ...tier3, altText: tier3.altText ?? "" }}
      benefitsSections={benefitsSections.map((section) => {
        return {
          ...section,
          benefits: section.benefits.map((benefit) => {
            return {
              ...benefit,
              tier1Label: benefit.tier1Label ?? "",
              tier2Label: benefit.tier2Label ?? "",
              tier3Label: benefit.tier3Label ?? "",
            };
          }),
        };
      })}
      componentId={componentId}
    />
  );
};
